import type { ErrorCode, ErrorDetail } from '@/types/api';


export interface ParsedApiError {
  status: number | string | undefined;
  code: ErrorCode | undefined;
  field: string | undefined;
  message: string;
  reason: string | undefined;
}

export function parseApiError(err: unknown): ParsedApiError {
  const e = err as { status?: number | string; data?: { errors?: ErrorDetail[] } } | undefined;
  const detail = e?.data?.errors?.[0];
  const detailsReason = detail?.details?.['reason'];
  return {
    status: e?.status,
    code: detail?.code,
    field: detail?.field,
    message: detail?.message ?? 'Something went wrong. Please try again.',
    reason: typeof detailsReason === 'string' ? detailsReason : undefined
  };
}

export function isTransportOrServerError(err: unknown): boolean {
  const { status } = parseApiError(err);
  if (typeof status === 'number') return status >= 500;
  return typeof status === 'string';
}
